import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useSchoolBrand } from '../../hooks/useSchoolBrand';
import {
  HomeIcon, BuildingOfficeIcon, PlusCircleIcon, XMarkIcon, Cog6ToothIcon,
  CalendarDaysIcon, BanknotesIcon, ClipboardDocumentCheckIcon, MegaphoneIcon,
} from '@heroicons/react/24/outline';

const NAV = [
  { label: 'OVERVIEW', items: [
    { name: 'Dashboard',   href: '/owner/dashboard',        icon: HomeIcon },
  ]},
  { label: 'BRANCHES', items: [
    { name: 'My Branches', href: '/owner/branches',         icon: BuildingOfficeIcon },
    { name: 'Add Branch',  href: '/owner/add-branch',       icon: PlusCircleIcon },
  ]},
  { label: 'ADMIN MANAGEMENT', items: [
    { name: 'Attendance',  href: '/owner/admin-attendance', icon: CalendarDaysIcon },
    { name: 'Salary',      href: '/owner/admin-salary',     icon: BanknotesIcon },
    { name: 'Leaves',      href: '/owner/admin-leaves',     icon: ClipboardDocumentCheckIcon },
    { name: 'Notices',     href: '/owner/notices',          icon: MegaphoneIcon },
  ]},
  { label: 'SETTINGS', items: [
    { name: 'Settings',    href: '/owner/settings',         icon: Cog6ToothIcon },
  ]},
];

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
  .os-wrap * { box-sizing:border-box; }
  .os-wrap { width:230px; min-width:230px; height:100vh; background:#1e1b4b; display:flex; flex-direction:column; overflow-x:hidden; font-family:'Sora',sans-serif; flex-shrink:0; z-index:50; }
  .os-brand { padding:20px 20px 16px; border-bottom:1px solid rgba(255,255,255,.08); position:relative; }
  .os-logo  { display:flex; align-items:center; gap:10px; }
  .os-logo-icon { width:36px; height:36px; background:linear-gradient(135deg,#7c3aed,#4f46e5); border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:.9rem; font-weight:700; color:white; flex-shrink:0; }
  .os-logo-text { font-size:.88rem; font-weight:700; color:white; line-height:1.2; }
  .os-logo-sub  { font-size:.62rem; color:rgba(255,255,255,.4); text-transform:uppercase; letter-spacing:.08em; margin-top:2px; }
  .os-nav { flex:1; padding:12px 10px; overflow-y:auto; overflow-x:hidden; scrollbar-width:none; }
  .os-nav::-webkit-scrollbar { display:none; }
  .os-group-label { font-size:.6rem; font-weight:700; color:rgba(255,255,255,.25); text-transform:uppercase; letter-spacing:.1em; padding:0 10px; margin:14px 0 6px; }
  .os-item { display:flex; align-items:center; gap:10px; padding:9px 12px; border-radius:10px; color:rgba(255,255,255,.55); font-size:.8rem; font-weight:500; text-decoration:none; transition:all .15s; margin-bottom:2px; }
  .os-item-text { flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .os-item:hover { background:rgba(255,255,255,.07); color:rgba(255,255,255,.9); }
  .os-item.active { background:rgba(124,58,237,.35); color:#c4b5fd; }
  .os-item svg { width:16px; height:16px; stroke-width:1.8; flex-shrink:0; }
  .os-footer { padding:12px 10px; border-top:1px solid rgba(255,255,255,.08); font-size:.68rem; color:rgba(255,255,255,.25); text-align:center; }
  .os-close { display:none; position:absolute; top:14px; right:14px; width:28px; height:28px; border-radius:7px; border:none; background:rgba(255,255,255,.1); color:white; cursor:pointer; align-items:center; justify-content:center; }
  .os-close svg { width:14px; height:14px; stroke-width:2; }
  @media (max-width:768px) {
    .os-wrap { position:fixed; left:-230px; top:0; transition:left .25s ease; }
    .os-wrap.open { left:0; }
    .os-close { display:flex; }
  }
`;

export default function OwnerSidebar({ open, onClose }) {
  const location = useLocation();
  const { brand } = useSchoolBrand();

  return (
    <>
      <style>{css}</style>
      <div className={`os-wrap${open ? ' open' : ''}`}>
        <button className="os-close" onClick={onClose}><XMarkIcon /></button>
        <div className="os-brand">
          <div className="os-logo">
            {brand.logo
              ? <img src={brand.logo} alt="logo" style={{width:36,height:36,borderRadius:10,objectFit:'contain',background:'rgba(255,255,255,.95)',padding:2,border:'1px solid rgba(255,255,255,.12)',flexShrink:0}}/>
              : <div className="os-logo-icon">O</div>
            }
            <div>
              <div className="os-logo-text">{brand.name || 'School Portal'}</div>
              <div className="os-logo-sub">Owner Panel</div>
            </div>
          </div>
        </div>
        <nav className="os-nav">
          {NAV.map(group => (
            <div key={group.label}>
              <div className="os-group-label">{group.label}</div>
              {group.items.map(item => {
                const active = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
                return (
                  <Link key={item.name} to={item.href} className={`os-item${active ? ' active' : ''}`} onClick={onClose}>
                    <item.icon /><span className="os-item-text">{item.name}</span>
                  </Link>
                );
              })}
            </div>
          ))}
        </nav>
        <div className="os-footer">Owner Panel · v1.0</div>
      </div>
    </>
  );
}